import { render, staticRenderFns } from "./RoleUsers.vue?vue&type=template&id=9f45a51e&"
import script from "./RoleUsers.vue?vue&type=script&lang=js&"
export * from "./RoleUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports